import { useContext } from "react";
import ReferrerContext from "../Contexts/ReferrerContext";
export const useReferrerContext = () => {
  return useContext(ReferrerContext);
};
